import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import colControl from '@/components/colControl/colControl';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { ChangeColMixin } from '@/mixins/ChangeColMixin1';
import { downloadFile } from '@/api/manage';
import trend from '@/components/biChart/trend';
import { pageMixin } from '@/mixins/pageMixin';
import CustomPagination from '@comp/page/custom-pagination';
import moment from 'moment';
export default {
  name: 'waterData',
  data: function data() {
    return {
      url: '/online/cn2011/device/',
      moment: moment,
      scroll: {
        y: 540
      },
      exportUrl: '/online/export/qingdao_2011',
      trendObj: {}
    };
  },
  components: {
    CustomPagination: CustomPagination,
    trend: trend,
    colControl: colControl
  },
  mixins: [GetSiteIdMixin, ChangeColMixin, pageMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.checkAll = true;
      this.indeterminate = false;
      this.delayLoadData();

      if (window.sessionStorage.getItem('siteType')) {
        this.getCol(window.sessionStorage.getItem('siteType'));
      }

      this.getPages(1, 100);
    },
    loadNum: function loadNum(value) {
      var _this = this;

      console.log(this.columns);
      console.log(this.options);
      console.log(this.dataSource);

      if (this.options.length > 0) {
        var legendData = [];
        var xData = [];
        var seriesData = [];
        this.options.forEach(function (item, index) {
          legendData.push(item.label);
          var newObj = {};
          newObj['name'] = item.label;
          newObj['type'] = 'line';
          var arr = [];

          _this.dataSource.forEach(function (item1, index1) {
            if (item1.factor && item1.factor[item.value]) {
              arr.push(item1.factor[item.value].value);
            } else {
              arr.push('');
            }
          });

          newObj['data'] = arr;
          seriesData.push(newObj);
        });
        this.dataSource.forEach(function (item, index) {
          xData.push(item.dataTime);
        });
        var obj = {
          legendData: legendData,
          seriesData: seriesData,
          xData: xData
        };
        this.trendObj = obj;
        console.log(obj);
      }
    }
  },
  created: function created() {
    this.queryParam.stime = moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');
  },
  methods: {
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.loadData();
    },
    onDateOk: function onDateOk(value) {
      console.log(value);
    } // handleExportXls(s) {
    //   let queryParam = JSON.parse(JSON.stringify(this.queryParam))
    //   this.$refs.colControl?queryParam.factorCodes = this.$refs.colControl.selectCol.join(','):''
    //   downloadFile(s, "/online/export/qingdao_2011", queryParam)
    // },

  }
};